import React from "react";
import "./home.css";
export const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.linkedin.com/in/gurmeet-singh-1ab8691a9/"
        className="home__social-icon"
        target="_balnk"
      >
        <i className="bx bxl-linkedin"></i>
      </a>
      <a
        href="https://www.linkedin.com/in/gurmeet-singh-1ab8691a9/"
        className="home__social-icon"
        target="_balnk"
      >
        <i className="uil uil-dribbble"></i>
      </a>
      <a
        href="https://github.com/"
        className="home__social-icon"
        target="_balnk"
      >
        <i className="uil uil-github-alt"></i>
      </a>
    </div>
  );
};
